/**
 * 提供全局方法
 * (c) 2017 进门web团队
 * **/

'use strict';

import 'core-js/features/array/at';

import * as pdfjs from 'pdfjs-dist/legacy/build/pdf.mjs';

import {
	APPSTORE,
	APP_BROWSER_HIDDEN_NAVIGATION_BAR_BACK,
	APP_BROWSER_HIDDEN_NAVIGATION_BAR_BACKGROUND,
	APP_BROWSER_HIDDEN_NAVIGATION_BAR_SHARE,
	APP_BROWSER_HIDDEN_NAVIGATION_BAR_TITLE,
	APP_BROWSER_HIDDEN_VIEW_FAILED_PROMPT,
	APP_BROWSER_HIDDEN_VIEW_LOADING_ANIMATION,
	APP_BROWSER_HIDDEN_VIEW_LOADING_PROGRESS,
	APP_BROWSER_STYLE_DISABLE_SCROLL,
	APP_BROWSER_STYLE_NAVIGATION_BAR_BACKGROUND_DARK,
	APP_BROWSER_STYLE_NAVIGATION_BAR_BACK_LIGHT,
	APP_BROWSER_STYLE_NAVIGATION_BAR_SHARE_LIGHT,
	APP_BROWSER_STYLE_NAVIGATION_BAR_TITLE_LIGHT,
	APP_BROWSER_STYLE_STATUS_BAR_LIGHT,
	APP_BROWSER_STYLE_VIEW_BACKGROUND_DARK,
	APP_BROWSER_STYLE_VIEW_FAILED_PROMPT_DARK,
	APP_BROWSER_STYLE_VIEW_LOADING_ANIMATION_DARK,
	APP_BROWSER_STYLE_VIEW_LOADING_PROGRESS_DARK,
	OPENID,
	PDFCODE,
	PDFVIEWERURL,
	THIRDPARTY,
	THIRDPARTYURL,
	TOKEN_CODE,
	USERINFOKEY,
	isBuild
} from './const';
import i18n, { EN, ZH, ZH_HK } from '@/assets/js/i18n';

import CryptoJS from 'crypto-js';
import { FILE_VIEWER_URL } from '@/fetch/host';
import NativeApp from '@/utils/app';
import Vue from 'vue';
import { toBlob } from 'html-to-image';

pdfjs.GlobalWorkerOptions.workerSrc = 'https://image.comein.cn/web/irm/js/pdfjs-dist/pdf.worker.min.legacy-4.3.136.mjs'

const vue = new Vue({});

// 区分中信证券组织的uc:测试：45d0c031-c6c4-4b51-92ae-cd98771e3e5e，生产：ac3eafa9-75cb-4bf2-ba95-b18f1071288f，（后台已做处理）
export const ZhongxzqUC = isBuild ? 'ac3eafa9-75cb-4bf2-ba95-b18f1071288f' : 'ac3eafa9-75cb-4bf2-ba95-b18f1071288f';

// 区分中信建投证券的uc生产和测试
export const ZhongxjtUC = isBuild ? 'c5f8c504-ec84-4f2d-aa58-6294e037c857' : '43edcb82-41a8-4933-ad82-846c74482560';

// 区分中金公司的uc生产和测试
export const ZhongjgsUC = isBuild ? '88093483-da5c-44b2-a8ed-1d2413eef57a' : 'fd88e7ff-d7de-45ae-ae2a-9a77906c00d3';

/**
 * 客户端UA配置手机状态栏高度参数（StatusHeight）
 * 优先取 客户端UA配置了高度参数
 *    再给默认值：只处理IphoneX和其他
 * */
export const appStatusHeight = () => {
	const UAMatchSH = navigator.userAgent.match(/(statusheight\/[0-9]*)/gi);
	if (UAMatchSH) {
		return UAMatchSH[0].split('/')[1];
	} else if (isApp) {
		return isIphoneX ? 44 : isAndroid || isOpenHarmony ? 24 : 20;
	} else {
		return 0;
	}
};

/**
 * APP 浏览器配置
 * 除了 *隐藏加载进度条* 默认是 true，其余全部是false
 * 如果需要显示，手动给 ： showViewLoadingProgress
 * @config { Array }
 * 可选参数(严格按照这些名字给参数)：[
 * 隐藏加载动画
 * "hideViewLoadingAnimation",
 * *-* 隐藏/显示 加载进度条 *-*
 * "showViewLoadingProgress",
 * "hideViewLoadingProgress",
 * 隐藏错误提示
 * "hideViewFailedPrompt",
 * 隐藏导航栏背景
 * "hideNavigationBarBackground",
 * 隐藏返回按钮
 * "hideNavigationBarBack",
 * 隐藏标题
 * "hideNavigationBarTitle",
 * 隐藏分享按钮
 * "hideNavigationBarShare",
 *
 * 状态栏颜色 - 亮色
 * "statusBarLight",
 * 页面背景 - 暗色
 * "viewBackgroundDark",
 * 页面加载动画颜色 - 暗色
 * "viewLoadingAnimationDark",
 * 页面加载进度条 - 暗色
 * "viewLoadingProgressDark",
 * 页面加载失败提示 - 暗色
 * "viewFailedPromptDark",
 * 导航背景-暗色
 * "navigationBarBackgroundDark",
 * 返回按钮 - 亮色
 * "navigationBarBackLight",
 * 标题颜色 - 亮色
 * "navigationBarTitleLight",
 * 分享按钮 - 亮色
 * "navigationBarShareLight"
 * 禁止浏览器滚动
 * "disableScroll"
 * ]
 */
export const configAppBrowser = config => {
	let intVal = 0;

	if (config.indexOf('hideViewLoadingAnimation') > -1) {
		intVal += APP_BROWSER_HIDDEN_VIEW_LOADING_ANIMATION;
	}
	// 特殊处理 进度条的显示，默认隐藏，只要没有给显示，就隐藏
	if (config.indexOf('showViewLoadingProgress') < 0) {
		intVal += APP_BROWSER_HIDDEN_VIEW_LOADING_PROGRESS;
	}
	if (config.indexOf('hideViewFailedPrompt') > -1) {
		intVal += APP_BROWSER_HIDDEN_VIEW_FAILED_PROMPT;
	}
	if (config.indexOf('hideNavigationBarBackground') > -1) {
		intVal += APP_BROWSER_HIDDEN_NAVIGATION_BAR_BACKGROUND;
	}
	if (config.indexOf('hideNavigationBarBack') > -1) {
		intVal += APP_BROWSER_HIDDEN_NAVIGATION_BAR_BACK;
	}
	if (config.indexOf('hideNavigationBarTitle') > -1) {
		intVal += APP_BROWSER_HIDDEN_NAVIGATION_BAR_TITLE;
	}
	if (config.indexOf('hideNavigationBarShare') > -1) {
		intVal += APP_BROWSER_HIDDEN_NAVIGATION_BAR_SHARE;
	}
	if (config.indexOf('statusBarLight') > -1) {
		intVal += APP_BROWSER_STYLE_STATUS_BAR_LIGHT;
	}
	if (config.indexOf('viewBackgroundDark') > -1) {
		intVal += APP_BROWSER_STYLE_VIEW_BACKGROUND_DARK;
	}
	if (config.indexOf('viewLoadingAnimationDark') > -1) {
		intVal += APP_BROWSER_STYLE_VIEW_LOADING_ANIMATION_DARK;
	}
	if (config.indexOf('viewLoadingProgressDark') > -1) {
		intVal += APP_BROWSER_STYLE_VIEW_LOADING_PROGRESS_DARK;
	}
	if (config.indexOf('viewFailedPromptDark') > -1) {
		intVal += APP_BROWSER_STYLE_VIEW_FAILED_PROMPT_DARK;
	}
	if (config.indexOf('navigationBarBackgroundDark') > -1) {
		intVal += APP_BROWSER_STYLE_NAVIGATION_BAR_BACKGROUND_DARK;
	}
	if (config.indexOf('navigationBarBackLight') > -1) {
		intVal += APP_BROWSER_STYLE_NAVIGATION_BAR_BACK_LIGHT;
	}
	if (config.indexOf('navigationBarTitleLight') > -1) {
		intVal += APP_BROWSER_STYLE_NAVIGATION_BAR_TITLE_LIGHT;
	}
	if (config.indexOf('navigationBarShareLight') > -1) {
		intVal += APP_BROWSER_STYLE_NAVIGATION_BAR_SHARE_LIGHT;
	}
	if (config.indexOf('disableScroll') > -1) {
		intVal += APP_BROWSER_STYLE_DISABLE_SCROLL;
	}
	return intVal;
};

/**
 * addHandler
 * @element
 * */
export const addHandler = (element, type, handler) => {
	// addEventListener 兼容性检查
	if (element.addEventListener) {
		element.addEventListener(type, handler, false);
	} else if (element.attachEvent) {
		element.attachEvent('on' + type, handler);
	} else {
		element['on' + type] = handler;
	}
};

/**
 * Base64 解加密
 *
 * @param  { String } stringToEncode/encodedData
 * @return { String } encodedData/stringDecode
 * **/
export const Base64_encode = stringToEncode => {
	const encodeUTF8string = function (str) {
		return encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
			return String.fromCharCode('0x' + p1);
		});
	};

	if (typeof window !== 'undefined') {
		if (typeof window.btoa !== 'undefined') {
			window.btoa(encodeUTF8string(stringToEncode));
		}
	} else {
		return new Buffer(stringToEncode).toString('base64');
	}
	const b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	let o1,
		o2,
		o3,
		h1,
		h2,
		h3,
		h4,
		bits,
		i = 0,
		ac = 0,
		enc = '',
		tmpArr = [];
	if (!stringToEncode) {
		return stringToEncode;
	}
	stringToEncode = encodeUTF8string(stringToEncode);
	do {
		o1 = stringToEncode.charCodeAt(i++);
		o2 = stringToEncode.charCodeAt(i++);
		o3 = stringToEncode.charCodeAt(i++);
		bits = (o1 << 16) | (o2 << 8) | o3;
		h1 = (bits >> 18) & 0x3f;
		h2 = (bits >> 12) & 0x3f;
		h3 = (bits >> 6) & 0x3f;
		h4 = bits & 0x3f;
		tmpArr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
	} while (i < stringToEncode.length);
	enc = tmpArr.join('');
	const r = stringToEncode.length % 3;
	return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
};

export const Base64_decode = encodedData => {
	const decodeUTF8string = function (str) {
		return decodeURIComponent(
			str
				.split('')
				.map(function (c) {
					return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
				})
				.join('')
		);
	};

	if (typeof window !== 'undefined') {
		if (typeof window.atob !== 'undefined') {
			return decodeUTF8string(window.atob(encodedData));
		}
	} else {
		return new Buffer(encodedData, 'base64').toString('utf-8');
	}
	const b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	let o1,
		o2,
		o3,
		h1,
		h2,
		h3,
		h4,
		bits,
		i = 0,
		ac = 0,
		dec = '',
		tmpArr = [];
	if (!encodedData) {
		return encodedData;
	}
	encodedData += '';
	do {
		// unpack four hexets into three octets using index points in b64
		h1 = b64.indexOf(encodedData.charAt(i++));
		h2 = b64.indexOf(encodedData.charAt(i++));
		h3 = b64.indexOf(encodedData.charAt(i++));
		h4 = b64.indexOf(encodedData.charAt(i++));
		bits = (h1 << 18) | (h2 << 12) | (h3 << 6) | h4;
		o1 = (bits >> 16) & 0xff;
		o2 = (bits >> 8) & 0xff;
		o3 = bits & 0xff;
		if (h3 === 64) {
			tmpArr[ac++] = String.fromCharCode(o1);
		} else if (h4 === 64) {
			tmpArr[ac++] = String.fromCharCode(o1, o2);
		} else {
			tmpArr[ac++] = String.fromCharCode(o1, o2, o3);
		}
	} while (i < encodedData.length);
	dec = tmpArr.join('');
	return decodeUTF8string(dec.replace(/\0+$/, ''));
};

/**
 * 判断为空
 * **/

/**
 * 变量
 *
 * @param  { var } key
 * @return { Boolean }
 * **/
export const isEmpty = key => !key || typeof key === 'undefined' || key === null;

/**
 * 数组
 *
 * @param  { Array<Object> } arr
 * @return { Boolean }
 * **/
export const isEmptyArray = arr => !arr.length;

/**
 * 对象
 *
 * @param  { Object } obj
 * @return { Boolean }
 * **/
export const isEmptyObject = obj => {
	if (typeof obj === 'object' && !(obj instanceof Array) && obj !== null) {
		for (let t in obj) return !1;
		return !0;
	}
};

function getTargetParamFromURL(targetKey) {
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get(targetKey);
}
export const isLinkMode = () => {
	const modeInUrl = getTargetParamFromURL('mode');
	return modeInUrl === 'link';
};
export const replaceLocation = (nextLang, url) => {
	const urlObj = new URL(url || window.location.href);
	if (nextLang) {
		urlObj.searchParams.set('lang', nextLang);
	}
	window.location.replace(urlObj.toString());
};

//正则校验。
//邮箱格式："名称@域名"，需要使用"^"匹配邮箱的开始部分，用"$"匹配邮箱结束部分以保证邮箱前后不能有其他字符
export const isEmail = str => {
	const emailRegex =
		/^(?!\.)(?!.*\.$)(?!.*\.\.)[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/i;
	return emailRegex.test(str);
};

/**
 * 路由
 * **/

/**
 * 将参数部分（search）转为对象
 *
 * @return { * }
 * **/
export const getUrlParam = s => {
	let urlParamObj = {},
		search = s || location.search;

	if (search.indexOf('?') > -1) {
		search = search.substr(1);
		const searchArr = search.split('&');

		for (let i = 0, len = searchArr.length; i < len; i++) {
			urlParamObj[searchArr[i].split('=')[0]] = decodeURIComponent(searchArr[i].split('=')[1]);
		}
	}

	return urlParamObj;
};

export const removeUrlParam = (url, props) => {
	let param = {};

	if (typeof props === 'string') {
		param[props] = '';
	} else {
		props.forEach(prop => {
			param[prop] = '';
		});
	}

	return mergeUrl(url, param);
};

/**
 * 聊天
 * */
// 解析聊天列表项
export const parseChatItem = mess => {
	// console.log(mess)
	// 自定义消息体
	const new_mess = {};
	new_mess.id = mess._id;
	new_mess.from = mess._from;
	new_mess.to = mess._to;
	new_mess.type = mess._type;
	new_mess.body = mess.body || mess._body;
	new_mess.subject = mess.subject || mess._subject;
	new_mess.uid = mess._from.split('@')[0];
	new_mess.uname = mess._uname || (mess.userinfo && mess.userinfo.uname) || null;
	new_mess.currenttime = mess.currenttime || mess._currenttime;
	new_mess.avatarurl = mess._avatarurl || (mess.userinfo && mess.userinfo.avatarurl) || null;
	new_mess.withdraw = mess._withdraw || null;
	// 查询消息 没有 identity，level这个字段。。。
	// new_mess.identity = isEmpty(mess._identity) ? mess.userinfo.identity : mess._identity;
	// new_mess.level = isEmpty(mess._level) ? mess.userinfo.level : mess._level;

	// 匹配 图片 不用转义，其余转义
	if (new_mess.id.match('activityimage')) {
		new_mess.body = new_mess.body.split('|')[1];
	} else {
		new_mess.body = Base64_decode(new_mess.body);
	}
	return new_mess;
};

// 匹配 表情 字段
export const regEmoji = str => {
	const reg = /\[[A-Za-z]+]|\[[\u4e00-\u9fa5]+]/g;
	return str.match(reg);
};

/**
 * 存储微信用户信息
 *
 * **/
export const saveWxUserInfo = v => {
	localStorage.setItem('wxUserInfo', JSON.stringify(v));

	// 如果存在cookie，先移除cookie，再保存到cookie
	if (getCookie('wxUserInfo')) {
		removeCookie('wxUserInfo');
	}

	setCookie('wxUserInfo', JSON.stringify(v));
};

export const removeWxUserInfo = () => {
	localStorage.removeItem('wxUserInfo');
	// 同时清除cookie
	removeCookie('wxUserInfo');
};

export const getWxUserInfo = () => {
	const wxUerInfo = localStorage.getItem('wxUserInfo') || getCookie('wxUserInfo');
	return isEmpty(wxUerInfo) ? null : JSON.parse(wxUerInfo);
};

/** 用户信息
 *
 * 获取userInfo
 **/
export const getUserInfo = () => {
	// 采用Base64加密
	const userInfo = localStorage.getItem(USERINFOKEY) || getCookie(USERINFOKEY);
	try {
		return JSON.parse(Base64_decode(userInfo));
	} catch (e) {
		return !isEmpty(userInfo) ? JSON.parse(userInfo) : null;
	}
};

// localStorage 保存 userInfo
export const saveUserInfo = v => {
	let comein_channel = getUrlParam().comein_channel;
	if (comein_channel) {
		v.comein_channel = comein_channel;
	}

	if (v !== 'undefined' && v !== undefined) {
		localStorage.setItem(USERINFOKEY, Base64_encode(JSON.stringify(v)));

		// 如果存在cookie，先移除cookie，再保存到cookie
		if (getCookie(USERINFOKEY)) {
			removeCookie(USERINFOKEY);
		}
		setCookie(USERINFOKEY, Base64_encode(JSON.stringify(v)));

		if (window.__bl && typeof window.__bl.setConfig === 'function') {
			window.__bl.setConfig({
				uid: v.uid,
				ignore: {
					ignoreErrors: ['ResizeObserver loop limit exceeded', 'Script error.']
				}
			});
		}
	}
};

// localStorage 保存 userInfo
export const removeUserInfo = () => {
	// if (Strophe.isConnected()){
	// 	Strophe.disConnect()
	// }
	console.log('🚀 ~ file: api.js:491 ~ removeUserInfo ~ USERINFOKEY:', USERINFOKEY);
	localStorage.removeItem(USERINFOKEY);

	// 同时清除cookie
	removeCookie(USERINFOKEY);
};

// openid
export const getOpenid = () => {
	return localStorage.getItem(OPENID) || getCookie(OPENID);
};

// wxOpenid
export const getWxOpenid = () => {
	const wxUserInfo = getWxUserInfo();
	return (wxUserInfo && wxUserInfo.openid) || null;
};

export const saveOpenid = v => {
	localStorage.setItem(OPENID, v);
	// 如果存在cookie，先移除cookie，再保存到cookie
	if (getCookie(OPENID)) {
		removeCookie(OPENID);
	}

	setCookie(OPENID, v);
};

export const removeOpenid = () => {
	localStorage.removeItem(OPENID);
	removeCookie(OPENID);
};

// 是否登录
export const isLogin = () => {
	const userInfo = getUserInfo();
	return !isEmpty(userInfo) && userInfo.hasOwnProperty('webtoken');
};

// 是否已绑定手机
export const isBoundPhone = () => {
	const userInfo = getUserInfo();
	return (
		!isEmpty(userInfo) &&
		userInfo.hasOwnProperty('webtoken') &&
		userInfo.hasOwnProperty('phonenumber') &&
		userInfo.phonenumber
	);
};

/**
 * 计算数字
 *
 * **/

/** 对比数字
 *@param {string} cVersion 需要对比的版本号
 *@param {string} bVersion 版本号界线
 * return {number} 小于返回-1;等于返回0;大于返回1
 * **/
export const getVersionCompared = (cVersion, bVersion) => {
	const cVersionArr = cVersion.split('.'),
		bVersionArr = bVersion.split('.');
	const length = Math.max(cVersionArr.length, bVersionArr.length);
	for (let i = 0; i < length; i++) {
		if (typeof cVersionArr[i] === 'undefined') cVersionArr.push('0');
		if (typeof bVersionArr[i] === 'undefined') bVersionArr.push('0');
		if (Number(cVersionArr[i]) < Number(bVersionArr[i])) {
			return -1;
		} else if (Number(cVersionArr[i]) > Number(bVersionArr[i])) {
			return 1;
		}
	}
	return 0;
};

/**
 * 四舍五入
 *
 * @param { Number } number
 * @param { Number } digit
 * **/
export const getMathRound = (number = 0, digit = 2) => {
	const exponent = Math.pow(10, digit);
	return Math.round(number * exponent) / exponent;
};

/**
 * 根据数组的某一个属性排序
 * @param { String } attr  排序的属性
 * @param { boolean } rev   true表示升序排列，false降序排序
 */
export const sortBy = (attr, rev) => {
	//第二个参数没有传递 默认升序排列
	if (rev == undefined) {
		rev = 1;
	} else {
		rev = rev ? 1 : -1;
	}
	return function (a, b) {
		a = a[attr];
		b = b[attr];
		if (a < b) {
			return rev * -1;
		}
		if (a > b) {
			return rev * 1;
		}
		return 0;
	};
};

/**
 * App 下载/更新
 * **/

/**
 * 跳转到App商店
 * **/
export const jumpToAppStore = () => {
	window.location.href = APPSTORE;
};

export const jumpToAppPage = () => {
	if (isWx) {
		// 微信中跳转引导浏览器打开页面
		location.href =
			THIRDPARTYURL + '/mobile/app-download?url=' + location.href.replace('/roadshow/room', '/roadshow/home');
	} else {
		if (isIos || isAndroid || isOpenHarmony) {
			let loadDateTime = new Date();
			let timeOut = setTimeout(() => {
				let timeOutDateTime = new Date();
				if (timeOutDateTime - loadDateTime > 3000) {
					clearTimeout(timeOut);
					window.location = APPSTORE;
				} else {
					window.close();
				}
			}, 500);
			let preventDefault = function (e) {
				e = e || window.event;
				if (e.preventDefault) {
					e.preventDefault();
				} else {
					e.returnValue = false;
				}
			};
			preventDefault();
			window.location.href = isIos
				? `comein://` +
				location.host +
				location.pathname.replace('/roadshow/room', '/roadshow/home') +
				location.search
				: `comein://applinkevent.comein.cn?url=` + location.href.replace('/roadshow/room', '/roadshow/home');
		}
	}
};

/**
 * 设备管理 device management
 * **/

/**
 * 浏览器 browser
 * 内核 kernel & 版本 version
 *
 * @return {*}  kernel, version
 * **/
export const getBrowser = () => {
	let s,
		kernel = '',
		version = '',
		ua = navigator.userAgent.toLowerCase();

	//探测浏览器
	const browserRules = [
		{ name: 'ie', regex: /msie ([\d.]+)/ },
		{ name: 'firefox', regex: /firefox\/([\d.]+)/ },
		{ name: 'chrome', regex: /chrome\/([\d.]+)/ },
		{ name: 'opera', regex: /opera.([\d.]+)/ },
		{ name: 'safari', regex: /version\/([\d.]+).*safari/ }
	];

	for (let i = 0; i < browserRules.length; i++) {
		const match = ua.match(browserRules[i].regex);
		if (match) {
			_set(browserRules[i].name, _toFixedVersion(match[1]));
			break;
		}
	}

	function _toFixedVersion(ver, floatLength) {
		ver = ('' + ver).replace(/_/g, '.');
		floatLength = floatLength || 1;
		ver = String(ver).split('.');
		ver = ver[0] + '.' + (ver[1] || '0');
		ver = Number(ver).toFixed(floatLength);
		return ver;
	}

	function _set(k, v) {
		kernel = k;
		version = v;
	}

	return {
		kernel,
		version
	};
};

/**
 * 机型 devices
 * **/
// depend isIos isAndroid
// 京东金融(isJdjr)
// 招商证券(isZszq)
// 长江证券(isCjzq)
// 海通证券(isHtzq)
// 华泰证券(isHuatzq)
// 中信证券(isZhongxzq)
// 中信建投(isZxjt)
// 中银证券(isZyzq)
// 中金公司(isZjgs)
// 广发证券(isGfzq)
export const isHtzq =
	/ehtsec/i.test(navigator.userAgent.toLowerCase()) ||
	(getUrlParam() && getUrlParam().comein_channel === 'htzq') ||
	(sessionStorage.getItem(THIRDPARTY) && JSON.parse(sessionStorage.getItem(THIRDPARTY)).comein_channel === 'htzq');

export const isHuatzq =
	(getUrlParam() && getUrlParam().comein_channel === 'huataizq') ||
	(sessionStorage.getItem(THIRDPARTY) &&
		JSON.parse(sessionStorage.getItem(THIRDPARTY)).comein_channel === 'huataizq');

export const isZhongxzq =
	(getUrlParam() && getUrlParam().comein_channel === 'zhongxinzq') ||
	(sessionStorage.getItem(THIRDPARTY) &&
		JSON.parse(sessionStorage.getItem(THIRDPARTY)).comein_channel === 'zhongxinzq');

export const isZxjt =
	(getUrlParam() && getUrlParam().comein_channel === 'zhongxinjt') ||
	(sessionStorage.getItem(THIRDPARTY) &&
		JSON.parse(sessionStorage.getItem(THIRDPARTY)).comein_channel === 'zhongxinjt');

export const isGfzq =
	(getUrlParam() && getUrlParam().comein_channel === 'guangfazq') ||
	(sessionStorage.getItem(THIRDPARTY) &&
		JSON.parse(sessionStorage.getItem(THIRDPARTY)).comein_channel === 'guangfazq');

export const isZyzq =
	(getUrlParam() && getUrlParam().comein_channel === 'zyzq') ||
	(sessionStorage.getItem(THIRDPARTY) && JSON.parse(sessionStorage.getItem(THIRDPARTY)).comein_channel === 'zyzq');

export const isZjgs =
	(getUrlParam() && getUrlParam().comein_channel === 'zjgs') ||
	(sessionStorage.getItem(THIRDPARTY) && JSON.parse(sessionStorage.getItem(THIRDPARTY)).comein_channel === 'zjgs');

export const isAndroid = /Android/i.test(navigator.userAgent.toLowerCase());

export const isOpenHarmony = /OpenHarmony/i.test(navigator.userAgent.toLowerCase());

export const isApp = /ComeinFinance/i.test(navigator.userAgent.toLowerCase());

export const isZszq = /cmschina/i.test(window.navigator.userAgent.toLowerCase());

export const isCjzq = /cjsccjeh/i.test(window.navigator.userAgent.toLowerCase());

export const isJdjr = /JDJR-App/i.test(window.navigator.userAgent.toLowerCase());

export const isWx = /micromessenger/.test(window.navigator.userAgent.toLowerCase());

export const isWxWork = /wxwork/.test(window.navigator.userAgent.toLowerCase());

export const isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent.toLowerCase());

// export const isIphoneX = isIos && (window.screen.height === 812 && window.screen.width === 375);
export const isIphoneX =
	isIos &&
	((window.screen.height === 812 && window.screen.width === 375) ||
		(window.screen.height === 896 && window.screen.width === 414));

export const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);

export const isPc = !isIos && !isAndroid && !isOpenHarmony;

/* ios 支持 __wxjs_environment ， 安卓支持 UA */
export const isWxMiniProgram = /miniprogram/.test((window.__wxjs_environment || navigator.userAgent).toLowerCase());

export const isMiniDevtool = /wechatdevtools/.test(navigator.userAgent.toLowerCase());

// 第三方
// 加入 THIRDPARTY 关键词 标记第三方！！！
// export const isThirdParty = () => {
// 	// 若同时存在 comein_channel 和 comein_sign 两个参数时，认为是第三方
// 	// 并且更新sessionStorage
// 	// 否则：
// 	// 查看sessionStorage
// 	// 若有 THIRDPARTY 认为是第三方
// 	// 否则：
// 	// 不是第三方
// 	const searchObj = getUrlParam();
// 	const session_third_party = sessionStorage.getItem(THIRDPARTY);

// 	if (searchObj.comein_channel && searchObj.comein_sign) {
// 		sessionStorage.setItem(THIRDPARTY, JSON.stringify(searchObj));
// 		return true;
// 	} else if (isZszq || isCjzq || isHtzq || isJdjr || isHuatzq || isZhongxzq || isZxjt || isZjgs) {
// 		return true;
// 	}

// 	return !!session_third_party;

// };

// // H5 取非客户端、非小程序、非第三方
// export const isH5 = !isApp && !isWxMiniProgram && !isThirdParty();

/**
 * APP通讯协议 - web-native
 * **/

/**
 * 向APP发起请求
 *
 * @param {*} obj
 * **/
export const webNative = obj => {
	/* APP断增加 access 参数，判断第三方,值不能为空 */
	obj.access = obj.access || '1';

	// 先转为json字符串
	const postBody = JSON.stringify(obj);

	if (isAndroid || isOpenHarmony) {
		cmiBridge.postMessage(postBody);
	}
	if (isIos) {
		window.webkit.messageHandlers.cmiBridge.postMessage(postBody);
	}
};

/**
 * APP打开新页面（跳转新页面）
 * @param:  { url : 需要跳转的地址}
 * @param:  { type : //0.从下往上pop  比如打开pdf   1.从左往右push} 默认是 1
 * @param: { pdf : 添加pdf到下载文档列表}
 * */
export const appOpenUrl = param => {
	let body = {
		url: param.url,
		keepMedia: param.keepMedia,
		presentationType: param.type || 1
	};
	param.pdf && (body.pdf = param.pdf);
	NativeApp.openURL(body);
};

/**
 * app设置浏览器
 * */
export const appSetUIStyle = param => {
	NativeApp.setUIStyle(param);
};

/**
 * APP展示toast或loading
 *
 * @param { Object } param 参考文档
 *
 * @property { String } text 提示语，有默认值
 * @property { Number } isIndictorShow 1表示loading 0表示toast
 * @property { Number } hideAfterSecond n秒之后自动隐藏，可调用hideTip隐藏
 * @property { Number } userInteractionEnabled 点击遮盖层是否立即隐藏 1是,0否
 * **/
export const appShowTip = param => {
	NativeApp.showTip(param);
};

/**
 * APP隐藏tip
 * **/
export const appHideTip = () => {
	NativeApp.hideTip();
};

/**
 * APP进入回放
 *
 * @param { String } pid 回放id
 * **/

export const appGoPlayback = pid => {
	NativeApp.goPlayback({ pid });
};

/**
 * APP进入路演厅
 *
 * @param { String } eid
 * @param { Object } meta 路演厅参数
 * **/
export const appGoRoom = (eid, meta) => {
	const param = {
		rid: eid
	};
	if (meta) {
		param.meta = meta;
	}
	NativeApp.goRoom(param);
};

/**
 * APP进入自助会议
 *
 * @param { String } eid
 * @param { Object } meta
 * **/
export const appGoMeeting = (obj, meta) => {
	const param = {
		micphoneOn: obj.micphoneOn || 0,
		cameraOn: obj.cameraOn || 0,
		meetingCode: obj.meetingCode || 0,
		ignoringValidation: obj.ignoringValidation || 1
	};
	if (meta) {
		param.meta = meta;
	}
	NativeApp.goMeeting(param);
};

/**
 * 正则替换/匹配
 * **/

/**
 * 移除所有空格
 *
 * */
export const removeAllSpace = v => v.replace(/\s+/g, '');

// 移除所有超链接
export const removeAllHyperLink = html => {
	const reg = new RegExp(/<a[^>]*href=['"]([^"]*)['"].*?[^>]*>(.*?)<\/a>/gi);
	return reg.test(html) ? html.replace(reg, '') : html;
};

// 替换所有超链接为文本
export const replaceAllHyperLinkToText = html => {
	const reg = new RegExp(/<a[^>]*href=['"]([^"]*)['"].*?[^>]*>(.*?)<\/a>/gi);
	const regAnchoStart = new RegExp(/<a[^>]*href=['"]([^"]*)['"].*?[^>]*>/gi);
	const regAnchoEnd = new RegExp(/<\/a>/gi);
	return reg.test(html) ? html.replace(regAnchoStart, '').replace(regAnchoEnd, '') : html;
};

/**
 * 检测空白行
 *
 * 匹配任意空或空白字符，如果你什么也没输入，或输入的只有空格、回车、换行等字符，则匹配成功
 */
export const isBlank = str => {
	const reg = /^\s*$/;
	return reg.test(str);
};

/**
 * 验证URL地址
 *
 * **/
export const checkUrl = url => {
	let re = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/;
	return re.test(url);
};

/**
 * 提取字符串中第一个URL地址
 *
 * **/
export const getUrlFromString = string => {
	let rep = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?/;
	return string.match(rep) ? string.match(rep)[0] : null;
};

/**
 * 验证手机号
 *
 * @param  { String } phone
 * @return { Boolean }
 * **/
export const checkPhone = phone => /^1[34578]\d{9}$/.test(phone) || /^8\d+$/.test(phone);

/**
 * 清除 字符 前后空格
 *
 * @param  { String } str
 * @return { String }
 * **/
export const clearSpace = str => str.replace(/(^\s*)|(\s*)$/g, '');

/**
 * 密码输入框正则表达式
 * 非中文 6-20位数
 * @param { String } pwd
 */
export const checkPwd = pwd => /^[^\u4e00-\u9fa5]{0,20}$/.test(pwd);

/**
 * 替换文本中所有换行(\n)为<br/>
 *
 * @param  { String } str
 * @return { String }
 * **/
export const replaceAllLineBreakWithBr = str => {
	const reg = new RegExp(/\\+n/g);
	return reg.test(str) ? str.replace(reg, '<br/>') : str;
};

/**
 * 匹配html(以 p | div | a | span为例)
 * **/
export const resExpHtml = str => {
	const reg = new RegExp(/(<p|a|div|span).*(?=>)(.|\n)*?<\\?\/(p|a|div|span)>/g);
	return reg.test(str);
};

/**
 * 清除 内容中 \n | \\n
 * * **/
export const removeAllLineBreak = str => {
	const reg = new RegExp(/\\+n/g);
	return reg.test(str) ? str.replace(reg, '') : str;
};

/**
 * 去除字符串中 <br/>
 *
 * @param { String } str
 * **/
export const removeBr = str => {
	const reg = new RegExp(/<br\s*\\?\/?>/gi);
	return reg.test(str) ? str.replace(reg, '') : str;
};

/** 格式化手机号为 3-4-4结构
 * 兼容 进门账号登陆，所以，只处理纯数字
 * */
export const formatPhoneNum = v => {
	/* 去除所有空格 */
	const _v = removeAllSpace(v);

	/* 如果是非数字，直接返回 */
	if (isNaN(_v)) {
		return _v;
	} else {
		/* 满足 3-7位 */
		if (_v.length >= 3 && _v.length <= 7) {
			/* 前三位 */
			const first_part = _v.substr(0, 3);
			/* 后面几位 */
			const second_part = _v.substr(3);
			v = first_part + ' ' + second_part;
		} else if (_v.length > 7) {
			/* 前三位 */
			const first_part = _v.substr(0, 3);
			/* 中间4位 */
			const second_part = _v.substr(3, 4);
			/* 剩下所有 */
			const third_part = _v.substr(7);

			v = first_part + ' ' + second_part + ' ' + third_part;
		}

		return v;
	}
};

/**
 * 判断数据类型
 *
 * @param  arr/obj/fn
 * @return { Boolean }
 * **/
export const isArray = arr => Object.prototype.toString.call(arr) === '[object Array]';
export const isObject = obj => Object.prototype.toString.call(obj) === '[object Object]';
export const isFun = fn => Object.prototype.toString.call(fn) === '[object Function]';

/**
 * 时间格式化
 * **/
export const dateFormat = (date, fmt) => {
	const o = {
		'M+': date.getMonth() + 1, //月份
		'd+': date.getDate(), //日
		'h+': date.getHours() % 24 === 0 ? '00' : date.getHours() % 24,
		'H+': date.getHours(), //小时
		'm+': date.getMinutes(), //分
		's+': date.getSeconds(), //秒
		'q+': Math.floor((date.getMonth() + 3) / 3), //季度
		S: date.getMilliseconds() //毫秒
	};

	const week = {
		0: '\u65e5',
		1: '\u4e00',
		2: '\u4e8c',
		3: '\u4e09',
		4: '\u56db',
		5: '\u4e94',
		6: '\u516d'
	};

	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	if (/(E+)/.test(fmt)) {
		fmt = fmt.replace(
			RegExp.$1,
			(RegExp.$1.length > 1 ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') + week[date.getDay() + '']
		);
	}

	for (var k in o) {
		if (new RegExp('(' + k + ')').test(fmt)) {
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
		}
	}

	return fmt;
};

export const dateFormatMoment = (date, fmt) => {
	return vue.$moment(date).locale('zh-cn').format(fmt);
};

/** 时间显示年月日**/
export const dateFormatYearMonthDate = (date, t = '-') => {
	return dateFormat(new Date(Number(date)), `yyyy${t}MM${t}dd`);
};

/** 时间显示月日时间**/
export const dateFormatMonthDateTime = date => {
	return dateFormat(new Date(Number(date)), 'MM-dd HH:mm');
};

/** 时间显示月日时间**/
export const dateFormatMonthDateTimeSP = date => {
	return dateFormat(new Date(Number(date)), 'MM月dd日 HH:mm');
};
/** 时间显示年月日时间**/
export const dateFormatYearMonthDateTimeSP = date => {
	return dateFormat(new Date(Number(date)), 'yyyy年MM月dd日 HH:mm');
};

/** 时间显示月日时间**/
export const dateFormatYearMonthDateTime = (date, t = '-') => {
	return dateFormat(new Date(Number(date)), `yyyy${t}MM${t}dd HH:mm`);
};

/** 时间显示月日 **/
export const dateFormatMonthDate = date => {
	return dateFormat(new Date(Number(date)), 'MM月dd日');
};

/** 时间显示月日 **/
export const dateFormatMonthDateWithNumber = (date, t = '-') => {
	return dateFormat(new Date(Number(date)), `MM${t}dd`);
};

/** 时间显示月日星期 **/
export const dateFormatMonthDateWithWeek = date => {
	return dateFormatMoment(date, 'YYYY年MM月DD日(ddd) HH:mm');
};

/** 时间显示年月 **/
export const dateFormatYearMonth = date => {
	return dateFormat(new Date(Number(date)), 'yyyy/MM');
};

/** 时间显示日 **/
export const dateFormatDay = date => {
	return dateFormat(new Date(Number(date)), 'dd');
};

/** 时间显示时间 **/
export const dateFormatTime = date => {
	if (!date) return '';
	return dateFormat(new Date(Number(date)), 'HH:mm');
};
/** 时间区分今年与往年（今年不显示年份） */
export const dateFormatBetweenThisYearOrPreviousYears = date => {
	return new Date().getFullYear() == new Date(date).getFullYear()
		? dateFormatMonthDateTime(date)
		: dateFormatYearMonthDate(date);
};

// 单独获取星期
export const getWeek = function (date, lang = 'zh') {
	let week;
	const isZh = lang === 'zh';
	if (date.getDay() == 0) week = isZh ? '周日' : 'Sun';
	if (date.getDay() == 1) week = isZh ? '周一' : 'Mon';
	if (date.getDay() == 2) week = isZh ? '周二' : 'Tue';
	if (date.getDay() == 3) week = isZh ? '周三' : 'Wed';
	if (date.getDay() == 4) week = isZh ? '周四' : 'Thu';
	if (date.getDay() == 5) week = isZh ? '周五' : 'Fri';
	if (date.getDay() == 6) week = isZh ? '周六' : 'Sat';

	return week;
};

// 判断是否是今天
export const isToday = date => {
	return dateFormatYearMonthDate(date) === dateFormatYearMonthDate(Date.now());
};

// 判断是否是明天
export const isTomorrow = date => {
	return dateFormatYearMonthDate(date) === dateFormatYearMonthDate(Date.now() + 24 * 3600 * 1000);
};

/**
 * 根据key值对应的value值,放在新的数组里
 * @param k = 要匹配的key值
 * @param arr = 要进行筛选匹配的数据源
 * @returns {*}
 */
export const returnValueAccordingKey = (k, arr) => {
	let keyValueArr = [];
	arr.forEach(item => {
		for (let o in item) {
			o === k && keyValueArr.push(item[o]);
		}
	});
	return keyValueArr;
};

/**
 * 根据所需的属性值匹配数组内对应对象
 * @param k = 要匹配的参数
 * @param i = 与之匹配的值
 * @param arr = 检索的数组
 * **/
export const returnObjAccordingKey = (k, i, arr) => {
	let keyObj = arr.find(item => {
		return item[k] == i;
	});
	return keyObj;
};

/**
 * 倒计时计算年，天，时，分，秒
 * @param targetTime {Number/String} 目标时间（将来的设定时间）
 * @param startTime {Number/String} 开始时间（一般为现在时间）
 * @return {{years: *, days: *, hours: *, minutes: *, seconds: *}} 返回对象
 */
export const returnLeftTime = (targetTime, startTime) => {
	// 不足2位数补0方法
	function checkTime(i) {
		if (i < 10) {
			i = '0' + i;
		}
		return String(i);
	}

	let currTime = startTime || new Date().getTime();
	let leftTime = Number(targetTime) - Number(currTime);
	if (leftTime >= 0) {
		let years = parseInt(leftTime / 1000 / 60 / 60 / 24 / 365, 10); ////计算剩余的年
		let days = parseInt(leftTime / 1000 / 60 / 60 / 24, 10); //计算剩余的天数
		let hours = parseInt((leftTime / 1000 / 60 / 60) % 24, 10); //计算剩余的小时
		let minutes = parseInt((leftTime / 1000 / 60) % 60, 10); //计算剩余的分钟
		let seconds = parseInt((leftTime / 1000) % 60, 10); //计算剩余的秒数

		return {
			years: checkTime(years),
			days: checkTime(days),
			hours: checkTime(hours),
			minutes: checkTime(minutes),
			seconds: checkTime(seconds)
		};
	}
};

/**
 * 保存Cookie
 * @param key {String} 键
 * @param value {String} 值
 * @param expire {String/Number} 失效时间(单位小时)
 */
export const setCookie = (key, value, expire) => {
	let oDate = new Date();
	oDate.setHours(oDate.getHours() + expire);
	document.cookie = key + '=' + value + (expire === null ? '' : ';expires=' + oDate.toGMTString()) + ';path=/';
};

/**
 * 移除Cookie
 * @param key {String} 键
 */
export const removeCookie = key => {
	//这里只需要把Cookie保质期退回一天便可以删除
	const myDate = new Date();
	myDate.setTime(-1000); //设置时间
	const cookiesArray = document.cookie.split(';');
	for (let i = 0; i < cookiesArray.length; i++) {
		const varName = cookiesArray[i].split('=');
		/* 清除cookie BUG， document.cookie 取到的结果大于两个字段时，会在字段前面加一个 空格，所以，在做匹配时，需要手动去除前面空格 */
		if (varName[0].trim() === key) {
			document.cookie = varName[0] + "='';expires=" + myDate.toGMTString() + ';path=/';
			document.cookie = varName[0] + "='';expires=" + myDate.toGMTString() + ';path=/mobile';
		}
	}
};

/**
 * 获取Cookie
 * @param key {String} 键
 * @return {*}
 */
export const getCookie = key => {
	let cookieArr = document.cookie.split('; ');
	for (let i = 0; i < cookieArr.length; i++) {
		let arr = cookieArr[i].split('=');
		if (arr[0] === key) {
			return arr[1];
		}
	}
	return false;
};

/**
 * 计算返回单位
 * 使用场景: 行情模块
 * @param value {String} 传入的数值
 * @return {string} 返回携带单位的值
 */
export const computedUnit = value => {
	if (value) {
		const val = Number(value);
		if (Math.abs(val) >= Math.pow(10, 8)) {
			return '<span class="number">' + (val / Math.pow(10, 8)).toFixed(2) + '</span><span class="unit">亿</span>';
		} else if (Math.abs(val) >= 0 && val < Math.pow(10, 8)) {
			return '<span class="number">' + (val / Math.pow(10, 4)).toFixed(2) + '</span><span class="unit">万</span>';
		}
	} else {
		return '- -';
	}
};

/**
 * 两个数组合并一个对象
 * by ziJun
 * @param arr1 {Array} 被合并数组，在对象中以 键 存在
 * @param arr2 {Array} 被合并数组，在对象中以 值 存在
 * @return {Object} 返回键值对的对象
 */
export const arrContactObject = (arr1, arr2) => {
	let obj = {};
	for (let i = 0; i < arr1.length; i++) {
		obj[arr1[i]] = arr2[i];
	}
	return obj;
};

/**
 * 强制保留n位小数
 * @param value
 * @param n
 * @return {number}
 */
export const returnFloat = (value, n) => {
	let v = Math.round(parseFloat(value) * 100) / 100;
	let xsd = v.toString().split('.');
	if (xsd.length === 1) {
		v = v.toString() + '.' + '0'.repeat(n);
		return v;
	}
	if (xsd.length > 1) {
		if (xsd[1].length < n) {
			v = v.toString() + '0';
		}
		return v;
	}
};

/**
 * 去除v-html中的有关宽度的属性，否则在渲染的时候宽度会撑开屏幕的宽度
 * by ziJun
 * @param text {String} html字符串
 * @return {String} 去除宽度之后的html字符串
 */
export const wipeHtmlImgWidth = text => {
	let reg = /width(.*)px;/g;
	return text && text.replace(reg, '');
};

/**
 * 提供屏幕倍率计算（基于iphone6/7/8）
 * by ziJun
 */
export const screenMultiply = () => {
	return document.documentElement.clientWidth / 375;
};

/**
 * 获取当前日期的N个月前后的日期
 * by ziJun
 * @param months {number} N月，+N 表示N月之后; -N 表示N月之前
 * @param days {number} N日， +N 表示N天之后; -N 表示N天之前
 * @param isZero {boolean} 是否需要补零 true(默认) 需要;
 * @param joinSign {string} 日期连接符号 '-(默认)
 * @return {string} 输出需求格式
 */
export const getFewMonthAgoOrAfterDate = (months = 0, days = 0, isZero = true, joinSign = '-') => {
	let dt = new Date();
	dt.setMonth(dt.getMonth() + months, dt.getDate() + days);
	let Year = dt.getFullYear();
	let Month = dt.getMonth() + 1;
	let Day = dt.getDate();

	// 是否补零
	if (isZero) {
		Month = Month < 10 ? '0' + Month : Month;
		Day = Day < 10 ? '0' + Day : Day;
	}

	// 日期连接符号
	return `${Year}${joinSign}${Month}${joinSign}${Day}`;
};

/**
 * 返回9{0,13-uid.length}+uid 格式的虚拟手机号
 * @param uid {Number} 用户id
 */
export const fictitiousPhone = uid => {
	let str = '9999999999999';
	let uidLength = String(uid).length;
	let newStr = str.substring(0, str.length - uidLength) + uid;
	return newStr;
};
/**
 *
 *  */
export const isHaveQuery = (url, param) => {
	if (url.indexOf('?') > -1) {
		return url + '&' + param;
	} else {
		return url + '?' + param;
	}
};
/*
 * 合并地址参数
 * param 支持
 * 1、id=10086&comein_channel=zhongxinzq
 * 2、{id: 10086, comein_channel: 'zhongxinzq'}
 */
export const mergeUrl = (url, param) => {
	if (!param) {
		return url;
	}

	let query = {};
	let urls = url.split('?');
	let res = urls[0];

	let getValue = str => {
		str.split('&').forEach(str => {
			let index = str.indexOf('=');
			if (index > 0) {
				query[str.substring(0, index)] = str.substring(index + 1);
			}
		});
	};

	if (urls.length > 1 && urls[1]) {
		getValue(urls[1]);
	}

	if (typeof param === 'string') {
		getValue(param);
	} else {
		Object.assign(query, param);
	}

	let arrQuery = [];

	for (var key in query) {
		let value = query[key];
		if (value === undefined || value === null || value === '' || value === 'undefined' || value === 'null') {
			continue;
		}
		arrQuery.push(key + '=' + query[key]);
	}

	return res + (arrQuery.length > 0 ? '?' + arrQuery.join('&') : '');
};
/**
 * 判断浏览器语言是否是中文
 */
export const isChinese = () => {
	var lang = navigator.systemLanguage ? navigator.systemLanguage : navigator.language;
	lang = lang.substr(0, 2);
	return lang == 'zh';
};
/**
 * 获取移动端网络类型
 */
export const getNetType = () => {
	var ua = navigator.userAgent;
	var networkStr = ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other';
	networkStr = networkStr.toLowerCase().replace('nettype/', '');
	return networkStr;
};

/**
 * 防抖、 delay时间内只能触发一次、
 */
export const debounce = (fn, delay = 1000, start = true) => {
	let done = true;
	let timer = null;
	return function () {
		let _this = this;
		let args = arguments;

		// 首次执行
		if (start) {
			// 开关打开时，执行任务
			if (done) {
				done = false;
				fn.apply(_this, args);
			}
			// 清空上一次操作
			clearTimeout(timer);
			// 任务开关打开
			timer = setTimeout(function () {
				done = true;
			}, delay);
		} else {
			// 清空上一次操作
			clearTimeout(timer);
			// delay时间之后，任务执行
			timer = setTimeout(function () {
				fn.apply(_this, args);
			}, delay);
		}
	};
};

/**
 * 节流、delay时间内只能触发一次
 */
export const throttle = (fn, delay = 1000) => {
	let done = true;
	let timer = null;
	return function () {
		let _this = this;
		let args = arguments;

		// 开关打开时，执行任务
		if (done) {
			done = false;
			fn.apply(_this, args);
		}

		timer = setTimeout(function () {
			done = true;
		}, delay);
	};
};

export const catchClick = (fn, that) => {
	return function () {
		const _this = that ? that : this;
		let args = arguments;
		let isFrame = _this.$route.query.isFrame;
		let comein_channel = _this.$route.query.comein_channel;
		if (!isFrame || comein_channel === 'brm') {
			fn.apply(_this, args);
		} else {
			parent.postMessage({ path: _this.$route.path, event: 'click' }, '*');
		}
	};
};

/**
 * 初始化 api.baidu.map
 */
export const initBaiduMapApi = callback => {
	window.baiMapApiCallback = function () {
		console.log('initBaiduMap');
		typeof callback === 'function' && callback();
	};

	function hasBaiduMapApi() {
		let nodeList = document.querySelectorAll('script');
		return (
			Array.from(nodeList).filter(node => node.src && node.src.indexOf('https://api.map.baidu.com/') === 0)
				.length > 0
		);
	}

	function loadBaiduMapApi() {
		if (hasBaiduMapApi()) {
			return window.baiMapApiCallback();
		}

		var proSrc =
			'https://api.map.baidu.com/api?v=3.0&ak=pukE7Tk9azyGiAVfykE8AzhbKPe8T3rB&callback=baiMapApiCallback';
		var devSrc =
			'https://api.map.baidu.com/api?v=3.0&ak=ex87VRE2RQrH5Vv3ctrTg85wTZUvuyGF&callback=baiMapApiCallback';

		var script = document.createElement('script');
		script.src = isBuild ? proSrc : devSrc;
		document.body.appendChild(script);
	}

	loadBaiduMapApi();
};

//双属性去重
export const uniqueDoubleName = function (arr, name1, name2) {
	var result = [];
	var obj = {};
	for (var i = 0; i < arr.length; i++) {
		if (!obj[arr[i][name1] + '|' + arr[i][name2]]) {
			result.push(arr[i]);
			obj[arr[i][name1] + '|' + arr[i][name2]] = true;
		}
	}

	return result;
};

/* base64转为二进制 */
export const base64ToBlob = dataUrl => {
	// data URIs 的语法结构为：data:[<mediatype>][;base64],<dataUrl>
	// 我们只需要 <dataUrl> 部分
	dataUrl = dataUrl.split(',')[1];
	// 解码base-64编码的数据
	dataUrl = window.atob(dataUrl);
	// 无符号整型数组
	const u = new Uint8Array(dataUrl.length);
	// 转化为 Unicode 值
	for (let i = 0; i < dataUrl.length; i++) {
		u[i] = dataUrl.charCodeAt(i);
	}
	// 构建 Blob 类文件对象
	return new Blob([u], { type: 'image/png' });
};

export const blobToBase64 = blob => {
	return new Promise((resolve, reject) => {
		const fileReader = new FileReader();
		fileReader.onload = e => {
			resolve(e.target.result);
		};
		// readAsDataURL
		fileReader.readAsDataURL(blob);
		fileReader.onerror = () => {
			reject(new Error('blobToBase64 error'));
		};
	});
};
/**
 * 删除指定参数
 * url 地址
 * paramKey 参数名
 */
export const delParam = (urlStr, paramKey) => {
	var urlParam = urlStr.substr(urlStr.indexOf('?') + 1);
	var beforeUrl = urlStr.substr(0, urlStr.indexOf('?'));
	var nextUrl = '';

	var arr = new Array();
	if (urlParam != '') {
		var urlParamArr = urlParam.split('&');

		for (var i = 0; i < urlParamArr.length; i++) {
			var paramArr = urlParamArr[i].split('=');
			if (paramArr[0] != paramKey) {
				arr.push(urlParamArr[i]);
			}
		}
	}

	if (arr.length > 0) {
		nextUrl = '?' + arr.join('&');
	}
	return beforeUrl + nextUrl;
};

/**
 * 批量删除指定参数
 */
export const delUrlParams = (urlStr, paramKeysArr) => {
	var resStr = urlStr;
	for (var index = 0; index < paramKeysArr.length; index++) {
		resStr = delParam(resStr, paramKeysArr[index]);
	}
	return resStr;
};

// 跳转到投研小程序
export const initWxMiniProgramPath = (isComeInMP, fullPath) => {
	if (isComeInMP == 2) {
		fullPath = delUrlParams(fullPath, [
			'isComeInMP',
			'wxMiniUserInfo',
			'wxMiniOpenId',
			'deleteWxMiniUserInfo',
			'deleteWxMiniOpenId'
		]);

		fullPath = '/pages/empty/index?url=' + encodeURIComponent(fullPath);

		return '/package_account/pages/login/index?redirectUri=' + encodeURIComponent(fullPath);
	} else {
		return '/pages/login/login?web_path=' + encodeURIComponent(fullPath);
	}
};
// isComeInMP=2表示浙商小程序，isComeInMP=1表示进门小程序
export const isSrsMp = sessionStorage.getItem('isComeInMP') == 2 || location.href.indexOf('isComeInMP=2') != -1;

export const hideRelativeRoadshow = isSrsMp;

// 浙商小程序跳转逻辑
export const redirectSrsRoadshowCheck = function () {
	let userInfo = getUserInfo();
	let isInvestor = userInfo.isInvestor;

	let investorUrl = '/package_account/pages/org_auth/index';
	let activityUrl = '/package_roadshow/pages/activity/detail?id=' + this.srsRoadshowActivityId;

	let url = this.srsRoadshowStatus == 1 ? investorUrl : isInvestor ? activityUrl : investorUrl;

	wx.miniProgram.navigateTo({
		url
	});
};

/**
 * 添加水印参数
 *
 * @param  { Number } type 1: 文档水印 2：阿里云水印
 * @return { String } url
 * **/
export const addWatermark = function (url, type = 1) {
	const userInfo = getUserInfo();
	if (isEmpty(userInfo)) return url;

	const userLogin = userInfo.login || (userInfo.userinfo && userInfo.userinfo.login);
	if (!userLogin) return url;

	if (type == 2) {
		const userLogin_base64 = Base64_encode(userLogin);
		const watermark = `x-oss-process=image
		/watermark,type_d3F5LXplbmhlaQ,size_30,text_${userLogin_base64},color_D7D7D7,t_50,g_nw,y_50,rotate_337
		/watermark,type_d3F5LXplbmhlaQ,size_30,text_${userLogin_base64},color_D7D7D7,t_50,g_nw,x_250,y_80,rotate_337
		/watermark,type_d3F5LXplbmhlaQ,size_30,text_${userLogin_base64},color_D7D7D7,t_50,g_nw,x_500,y_110,rotate_337
		/watermark,type_d3F5LXplbmhlaQ,size_30,text_${userLogin_base64},color_D7D7D7,t_50,g_nw,x_750,y_130,rotate_337

		/watermark,type_d3F5LXplbmhlaQ,size_30,text_${userLogin_base64},color_D7D7D7,t_50,g_sw,x_50,y_80,rotate_337
		/watermark,type_d3F5LXplbmhlaQ,size_30,text_${userLogin_base64},color_D7D7D7,t_50,g_sw,x_300,y_60,rotate_337
		/watermark,type_d3F5LXplbmhlaQ,size_30,text_${userLogin_base64},color_D7D7D7,t_50,g_sw,x_550,y_40,rotate_337
		/watermark,type_d3F5LXplbmhlaQ,size_30,text_${userLogin_base64},color_D7D7D7,t_50,g_sw,x_800,y_0,rotate_337

		/watermark,type_d3F5LXplbmhlaQ,size_30,text_${userLogin_base64},color_D7D7D7,t_50,g_west,x_140,voffset_20,rotate_337
		/watermark,type_d3F5LXplbmhlaQ,size_30,text_${userLogin_base64},color_D7D7D7,t_50,g_west,x_390,voffset_-10,rotate_337
		/watermark,type_d3F5LXplbmhlaQ,size_30,text_${userLogin_base64},color_D7D7D7,t_50,g_west,x_640,voffset_-40,rotate_337`;
		url += (url.indexOf('?') > -1 ? '&' : '?') + watermark;
	} else {
		const watermark = 'text_' + userLogin + ',color_D7D7D7,size_12rem,opacity_0.3,rotate_315,col_4,row_3';
		url += (url.indexOf('?') > -1 ? '&' : '?') + 'watermark=' + watermark;

		let query = url.split('?')[1];
		url = url.split('?')[0] + '?options=' + encodeURIComponent(encrypt(query));
	}
	return url;
};

/**
 * AES对称加密
 */
export const encrypt = function (str, code) {
	let key = CryptoJS.enc.Utf8.parse(code);
	let srcs = CryptoJS.enc.Utf8.parse(str);
	let encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
	return encrypted.toString();
};
export const decrypt = function (str, pwd) {
	let key = CryptoJS.enc.Utf8.parse(pwd);
	let decrypt = CryptoJS.AES.decrypt(str, key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	});
	return CryptoJS.enc.Utf8.stringify(decrypt).toString();
};
// 使用方法：使用call方法改变this指向
export const goBackReplace = function (pathName, prevRouteName, query = {}) {
	if (prevRouteName && prevRouteName == pathName) {
		return this.$router.go(-1);
	}
	this.$router.replace({
		name: pathName,
		query
	});
};

// 金额大写
export const digitUppercase = function (n) {
	var fraction = ['角', '分'];
	var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
	var unit = [
		['元', '万', '亿'],
		['', '拾', '佰', '仟']
	];
	var head = n < 0 ? '欠' : '';
	n = Math.abs(n);
	var s = '';
	for (var i = 0; i < fraction.length; i++) {
		s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
	}
	s = s || '整';
	n = Math.floor(n);
	for (let i = 0; i < unit[0].length && n > 0; i++) {
		var p = '';
		for (let j = 0; j < unit[1].length && n > 0; j++) {
			p = digit[n % 10] + unit[1][j] + p;
			n = Math.floor(n / 10);
		}
		s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
	}
	return (
		head +
		s
			.replace(/(零.)*零元/, '元')
			.replace(/(零.)+/g, '零')
			.replace(/^整$/, '零元整')
	);
};

// 金额千分号
export const priceFormat = function (num) {
	if (num == undefined || num === '' || Number.isNaN(num)) {
		return '-';
	}
	return num.toString().replace(/\d+/, n => {
		return n.replace(/(\d)(?=(\d{3})+$)/g, $1 => {
			return $1 + ',';
		});
	});
};

/**
 * 单位为分的价格 转换成 单位为元的价格
 * 接口返回金额单位是分
 * @param  { String } cert
 * @return { String } 0.00(默认)
 * **/
export const certToRMBFormat = function (cert, point = 2) {
	return priceFormat(Number((Number(cert) / 100).toFixed(point)));
};

// 生成文字图片
export const getWatermarkTextPng = function (option = {}) {
	let userInfo = option.userInfo || getUserInfo();
	if (!userInfo) return '';

	let canvas,
		ctx,
		w = 260,
		h = 190,
		loginName = userInfo.login || (userInfo.userinfo && userInfo.userinfo.login) || '';

	if (!loginName) return '';

	canvas = document.createElement('canvas');
	const idName = 'watermarkCanvas' + Math.ceil(Math.random() * 1000);
	canvas.id = idName;
	canvas.style.display = 'none';
	document.body.appendChild(canvas);

	document.querySelector('#' + idName).width = w;
	document.querySelector('#' + idName).height = h;

	ctx = canvas.getContext('2d');

	ctx.rotate((337 * Math.PI) / 180);
	ctx.font = (option.font ? option.font : '22px') + ' sans-serif';
	ctx.textAlign = 'center';
	ctx.fillStyle = option.fillStyle || 'rgba(215,215,215, 0.3)';

	ctx.fillText(loginName, 50, canvas.height - 85);

	const img = canvas.toDataURL('image/png');
	document.body.removeChild(canvas);

	return img;
};

export const isVConsole = (() => {
	// pc打开不显示vconsole
	if (navigator.platform == 'Win32' && !isMiniDevtool) {
		return false;
	}

	const urlParam = getUrlParam();
	if (urlParam.vconsole) {
		localStorage.setItem('VCONSOLE', true);
	}

	return urlParam.vconsole || localStorage.getItem('VCONSOLE') || !isBuild;
})();

/**
 * 根据key值匹配对应的value值,适用场景例如：根据后端状态码，前端展示不同字段
 * @param k = 要匹配的key值
 * @param obj = 要进行筛选匹配的数据源
 * @returns {*}
 */
export const returnValueAccordingCode = (k, obj) => {
	if (typeof k === 'number') {
		for (let o in obj) {
			if (Number(o) === k) return obj[o];
		}
	} else {
		for (let o in obj) {
			if (o === k) return obj[o];
		}
	}
};

/**
 * 判断开头是否为进门域名
 * @param {String} url 链接
 * @returns
 */
export const judgeIsComeinDomain = url => {
	if (!url) return true;

	let reg = /^https:\/\/\w{0,}\.comein\.cn\S{0,}/;
	return reg.test(url);
};

/**
 * 打开外部链接
 * @param {String} url 链接
 * @returns
 */
export const openUrl = url => {
	if (!url) return true;
	if (isApp) {
		appOpenUrl({ url: url });
	} else {
		if (isWx) {
			const urlSplit = url.split('.');
			const isPDF = urlSplit[urlSplit.length - 1] === 'pdf';
			if (isPDF) {
				window.location.href = getPdfViewerUrl(url);
				return;
			}
		}

		window.location.href = url;
	}
};

export const isThisYear = time => {
	if (!time) return;
	if (new Date(Number(time)).getFullYear() == new Date().getFullYear()) {
		return dateFormat(new Date(Number(time)), 'MM-dd HH:mm');
	} else {
		return dateFormat(new Date(Number(time)), 'yyyy-MM-dd HH:mm');
	}
};

/** 企业号统一展示全年份 */
export const formatIrYear = time => {
	if (!time) return;

	const timeMoment = vue.$moment(time);
	// 没有时分信息的时候就不展示
	const hasTime = timeMoment.hours() !== 0 || timeMoment.minutes() !== 0 || timeMoment.seconds() !== 0;
	const format = hasTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD';
	return timeMoment.format(format);
};

/**
 * 对象数组去重 根据key去重
 * @param {*} key
 * @param {*} souce  原数组
 * 返回新数组
 */
export const removeArrayDuplicates = (key = 'id', source = []) => {
	if (key === '') return source;
	let obj = {};
	return source.reduce((prev, next) => {
		if (!obj[next[key]]) {
			obj[next[key]] = true;
			prev.push(next);
		}
		return prev;
	}, []);
};

// 小程序屏蔽购买流程
export const miniprogramNotAllowPayVirtual = function () {
	if (!isWxMiniProgram) {
		return false;
	}

	if (isIos) {
		this.$store.dispatch('showDialog', {
			dialog_alert: true,
			dialog_text: '由于相关规范，IOS功能暂不支持'
		});
	} else {
		this.$store.dispatch('showDialog', {
			dialog_affirm: true,
			dialog_text: '由于微信相关规定，暂不支持观看，如需观看请复制并粘贴链接至浏览器中打开！',
			dialog_confirm_text: '复制链接',
			dialog_confirm_btn: url => {
				this.$copyText(url || location.href).then(
					e => {
						this.$store.dispatch('showTooltip', { msg: '复制成功', time: 5000 });
					},
					e => {
						this.$store.dispatch('showTooltip', { msg: '复制失败', time: 5000 });
					}
				);
			}
		});
	}

	return true;
};

/**
 * 双时间格式化
 * 1、只有开始时间只返回开始时间的 HH:mm
 * 2、日期相同返回时间段 HH:mm - HH:mm
 * 3、日期不同返回日期时间段 MM月DD日 HH:mm - MM月DD日 HH:mm
 * @param { Number } startTime 必填
 * @param { Number } endTime 非必填
 * @param {*} lang
 * @returns
 */
export const formatRoadshowTime = (startTime, endTime, lang = ZH) => {
	// 判断开始时间与结束时间是否同一天
	const { isSameDay, isSameYear } = getDiffDay(startTime, endTime);

	if (!isSameDay) {
		if (!endTime) {
			return dateFormatYearMonthDateTime(startTime);
		}
		//  MM-dd- HH:mm - MM-dd- HH:mm
		if (lang === EN) {
			if (!isSameYear) {
				return `${dateFormatYearMonthDateTime(startTime)} - ${dateFormatYearMonthDateTime(endTime)}`;
			}
			return `${dateFormatMonthDateTime(startTime)} - ${dateFormatMonthDateTime(endTime)}`;
		}
		if (!isSameYear) {
			return `${dateFormatYearMonthDateTimeSP(startTime)} - ${dateFormatYearMonthDateTimeSP(endTime)}`;
		}
		//  MM月dd日 HH:mm - MM月dd日 HH:mm
		return `${dateFormatMonthDateTimeSP(startTime)} - ${dateFormatMonthDateTimeSP(endTime)}`;
	}
	// MM月dd日（周E） HH:mm - HH:mm
	if (lang === EN) {
		// 暂时这样处理，替换中文一，二，三，四，五，六，日到英文星期 Mon，Tues，Wed，Thur，Fri，Sat，Sun
		const week = dateFormat(new Date(startTime), 'E');
		const weekEnMap = {
			一: 'Mon',
			二: 'Tues',
			三: 'Wed',
			四: 'Thur',
			五: 'Fri',
			六: 'Sat',
			日: 'Sun'
		};
		const weekEn = weekEnMap[week];
		return `${dateFormatMonthDateWithNumber(startTime)} ${dateFormatTime(startTime)} - ${dateFormatTime(endTime)}`;
	}
	return `${dateFormatMonthDate(startTime)}${dateFormatTime(startTime)} - ${dateFormatTime(endTime)}`;
};

export const getDiffDay = (startTime, endTime) => {
	if (!startTime || !endTime)
		return {
			isSameYear: false,
			isSameDay: false
		};
	const start = new Date(startTime);
	const end = new Date(endTime);
	const startTimestamp = start.setHours(0, 0, 0, 0);
	const endTimestamp = end.setHours(0, 0, 0, 0);
	const diffDay = (endTimestamp - startTimestamp) / 24 / 60 / 60 / 1000;
	const isSameDay = diffDay === 0;
	return {
		isSameYear: start.getFullYear() === end.getFullYear(),
		isSameDay,
		diffDay
	};
};
export const scrollLeftTo = function (scroller, to, duration) {
	var count = 0;
	var from = scroller.scrollLeft;
	var frames = duration === 0 ? 1 : Math.round((duration * 1000) / 16);

	function animate() {
		scroller.scrollLeft += (to - from) / frames;

		if (++count < frames) {
			window.requestAnimationFrame(animate);
		}
	}

	animate();
};

export const getPdfViewerUrl = function (link, download = 0) {
	let reg = /^https:\/\/\w{0,}\.comein\.cn\S{0,}/.test(link);
	let pdfReg = /^.+(\.pdf)$/i.test(link); // 判断是不是pdf后缀
	if (reg && pdfReg) {
		link = PDFVIEWERURL + link + (download ? '&download=1' : '');
		let query = link.split('?')[1];
		link = link.split('?')[0] + '?options=' + encodeURIComponent(encrypt(query));
	}

	return link;
};

// 过滤富文本
export const unescapeText = function (html) {
	var s = '';
	if (html == undefined) return '';
	s = html.replace(/&amp;/g, '&');
	s = s.replace(/&lt;/g, '<');
	s = s.replace(/&gt;/g, '>');
	s = s.replace(/&nbsp;/g, ' ');
	s = s.replace(/&#39;/g, "'");
	s = s.replace(/&quot;/g, '"');
	s = s.replace(/<br\/>/g, '\n');
	s = s.replace(/&ldquo;/g, '"');
	s = s.replace(/&rdquo;/g, '"');
	s = s.replace(/&rarr;/g, '→');
	s = s.replace(/<\/?[^>]*>/g, ''); //过滤标签
	return s;
};

export const emptyInputValue = function (value) {
	if (!value) return true;
	if (value == '0') return true;
	if (Array.isArray(value) && value.length == 0) return true;
	if (JSON.stringify(value) == '{}') return true;
	return false;
};

export const setSignToken = async () => {
	// 获取签名token
	localStorage.setItem(
		'auth',
		'Bearer eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJsLUxTQmxlQWY0cldRZ0FCT0dQRFo4UzNlZDFUNEMwTHBGSkctcl82d2VnIn0.eyJleHAiOjE3OTIwNjA3ODksImlhdCI6MTcwNTY2MDc4OSwianRpIjoiNzE1MDkwNjM1Njk0OTcyNTE4NSIsImlzcyI6Imh0dHA6Ly9lLXNpZ24ta2V5Y2xvYWsudGVzdC5sYW4uY29tZWluLmNuL2F1dGgvcmVhbG1zL2lybS16emtnLWVzaWduIiwiYXVkIjoiYWNjb3VudCIsInN1YiI6IjcwMjkwMTI1Nzk5ODE4NjQ5NjAiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJpcm0tcGMtZnJvbnRlbmQiLCJzZXNzaW9uX3N0YXRlIjoiNzE1MDkwNjM1NjkyNDU1OTM2MCIsImFjciI6IjEiLCJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsiZGVmYXVsdC1yb2xlcy1pcm0tenprZy1lc2lnbiIsIm9mZmxpbmVfYWNjZXNzIiwiYWRtaW4iLCJ1bWFfYXV0aG9yaXphdGlvbiJdfSwicmVzb3VyY2VfYWNjZXNzIjp7ImFjY291bnQiOnsicm9sZXMiOlsibWFuYWdlLWFjY291bnQiLCJtYW5hZ2UtYWNjb3VudC1saW5rcyIsInZpZXctcHJvZmlsZSJdfX0sInNjb3BlIjoicHJvZmlsZSBlbWFpbCIsInNpZCI6IjcxNTA5MDYzNTY5MjQ1NTkzNjAiLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsInByZWZlcnJlZF91c2VybmFtZSI6IndhbmdhbnFpbmcifQ.DSm2KbjJt1C1DB29RxvSnBs_lEbf-qBXTwLngDklECItB85jeIngjEZssHYTGZpwCEAAJoOWD1do6WeA9AOqSvRhPKBajPyC5PUV_KJovWwdZVvB4x3vFSjUJ8DCtplmZKgrkq_qBCB9zUFLB9Bf7BxN2ny4vQIhuYuU9wzEsNWJ0WiXA0VEMjr0Bgi21XVsE4KPHhG5CaEHHB6OY-ta6W-muvF_PZasyBr6XG4ni3HUwELZn0Cl2qoHgsvF8aZZfx4T3fKKVDLSxqz139UlWxf-4vyrn0pGVc1n7cC-9QyYtRU9eXuMaEKbwTD0j8KL0vhtqEuSoicliU0OFEbt2w'
	);

	// const res = await axios.get(eVisaTask.accessExternalService, {
	// 	params: { "name": "esign" }

	// })

	// if (+res?.code === 0) {
	// 	console.log(res, 33333333)
	// 	const { token, service } = res.data
	// }
};

export const generateUUID = () => {
	let timestamp = new Date().getTime();
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		const r = (timestamp + Math.random() * 16) % 16 | 0;
		timestamp = Math.floor(timestamp / 16);
		return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
	});
};

export const toPhoneNumber = val => {
	if (!val) {
		return '-';
	}
	return val.substr(0, 3) + '****' + val.substr(7); // 输出为131****1234
};

export const convertToTransparentBase64 = base64ImageData => {
	return new Promise((resolve, reject) => {
		// 创建一个Image对象
		var img = new Image();

		// 设置Image对象的src为base64图片数据
		img.src = base64ImageData;

		// 当图像加载完成后执行回调函数
		img.onload = function () {
			// 创建一个Canvas元素
			var canvas = document.createElement('canvas');
			var ctx = canvas.getContext('2d');

			// 设置Canvas的宽度和高度与图像相同
			canvas.width = img.width;
			canvas.height = img.height;

			// 在Canvas上绘制图像
			ctx.drawImage(img, 0, 0);

			// 获取图像的像素数据
			var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
			var data = imageData.data;

			// 遍历每个像素，将白色背景替换为透明
			for (var i = 0; i < data.length; i += 4) {
				// 判断是否为白色（假设白色的RGB值为255, 255, 255）
				if (data[i] === 255 && data[i + 1] === 255 && data[i + 2] === 255) {
					// 将白色背景的像素设置为透明
					data[i + 3] = 0;
				}
			}

			// 将修改后的像素数据重新放回Canvas
			ctx.putImageData(imageData, 0, 0);

			// 将Canvas转换为带有透明底的base64图像数据
			var transparentBase64 = canvas.toDataURL('image/png');

			// 异步返回带有透明底的图片 base64 数据
			resolve(transparentBase64);
		};

		// 处理图像加载失败的情况
		img.onerror = function () {
			reject(new Error('Failed to load the image.'));
		};
	});
};

/**
 * 空值，返回默认值
 */
export const formatDefault = value => {
	if (value == undefined || value === '' || Number.isNaN(value)) {
		return '-';
	}
	return value;
};

export function selfFixed(n, digits) {
	n = +n;
	if (n > -1 / Math.pow(10, digits) && n < 1 / Math.pow(10, digits) && n != 0) {
		var i = 0;
		let num = n;
		while (Math.abs(num) < 1) {
			num *= 10;
			i++;
		}
		return n.toFixed(i + digits - 1);
	} else {
		return n.toFixed(digits);
	}
}

export const convertPxToRem = str => {
	const reg = /(\d+)px/g;
	const fontSize = parseFloat(document.documentElement.style.fontSize);
	return str.replace(reg, (_$0, $1) => `${parseFloat($1) / fontSize}rem`);
};

export const blobFile = (res, filename) => {
	let blob = new Blob([res]);
	let objectUrl = URL.createObjectURL(blob); //生成一个url
	let a = document.createElement('a');
	a.href = objectUrl;
	a.download = filename;
	a.click();
};

export async function delayToBlob(element, options, delay) {
	return new Promise(resolve => {
		setTimeout(async () => {
			const blob = await toBlob(element, options);
			resolve(blob);
		}, delay);
	});
}
// 获取App用户信息
export const getAppUserInfo = async () => {
	const res = await Promise.all([NativeApp.getUserInfo(), NativeApp.getClientInfo()]);
	let data = Object.assign({}, res[0].data, res[1].data);
	console.log(11, res[0].data, res[1].data);

	data.webtoken = data.token;
	saveUserInfo(data, false);

	return data;
};

function getFileExtension(url) {
	// 找到最后一个点号的索引位置
	const lastIndex = url.lastIndexOf('.');
	// 如果没有找到点号或者点号是字符串的最后一个字符，说明没有文件后缀
	if (lastIndex === -1 || lastIndex === url.length - 1) {
		return '';
	}
	// 返回点号后面的部分作为后缀名
	return `.${url.slice(lastIndex + 1)}`;
}
// 获取文件预览地址，公司内部服务地址
export const getFileViewerUrl = function (link, fileName = '') {
	if (!link) return '';
	let _affix = getFileExtension(link);
	// 文件长度会导致解析问题 需要裁剪
	if (fileName && typeof fileName === 'string') fileName = fileName.slice(0, 22);
	return `${FILE_VIEWER_URL}${encodeURIComponent(`${Base64_encode(`${link}?fullfilename=${fileName}${_affix}`)}`)}`;
};

/** 获取随机数 */
export const getUuid = (radix, len = 8) => {
	var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	let uuid = [];
	let i;
	radix = radix || chars.length;
	if (len) {
		for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
	} else {
		let r;
		uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
		uuid[14] = '4';
		for (i = 0; i < 36; i++) {
			if (!uuid[i]) {
				r = 0 | (Math.random() * 16);
				uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
			}
		}
	}
	return uuid.join('');
};

export const isNonValue = value => {
	// if (value == undefined || value === '' || Number.isNaN(value)) return true;
	if (value == undefined || value === '' || Number.isNaN(value) || Number(value) == 0) return true;
	return false;
};

export const getRect = el => {
	if (!el) return null;
	if (el instanceof window.SVGElement) {
		let rect = el.getBoundingClientRect();
		return {
			top: rect.top,
			left: rect.left,
			width: rect.width,
			height: rect.height
		};
	} else {
		return {
			top: el.offsetTop,
			left: el.offsetLeft,
			width: el.offsetWidth,
			height: el.offsetHeight
		};
	}
};

export const miniAwaitTo = promise => {
	return promise.then(data => [null, data]).catch(err => [err, null]);
};

export const checkSafeAreaInsetBottom = () => {
	// 获取底部安全距离，单位通常是px
	const safeAreaInsetBottom = parseFloat(
		getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-bottom')
	);

	// 将获取到的值转换为数值类型，以便进行比较和计算
	const safeAreaInsetBottomValue = parseInt(safeAreaInsetBottom, 10);

	if (!isNaN(safeAreaInsetBottomValue) && safeAreaInsetBottomValue > 0) {
		// console.log('存在底部安全距离，其高度为:', safeAreaInsetBottomValue, 'px');
		return true;
	} else {
		// console.log('不存在底部安全距离或者值无效');
		return false;
	}
};

//获取屏幕高度
export const get100vh = () => {
	if (isSafari) return `${window.innerHeight || document.documentElement.clientHeight}px`;
	return `100vh`;
};

export const isSameDay = (time1, time2) => {
	return new Date(time1).setHours(0, 0, 0, 0) === new Date(time2).setHours(0, 0, 0, 0);
};

// 格式化会议详情的时间
export const formatMeetingCopyTime = (startTime, endTime) => {
	// 判断开始时间与结束时间是否同一天
	const sameDay = isSameDay(startTime, endTime);
	if (!sameDay) {
		return `${dateFormatYearMonthDateTime(startTime, '/')}-${dateFormatYearMonthDateTime(endTime, '/')}`;
	}
	return `${dateFormatYearMonthDate(startTime, '/')} ${dateFormatTime(startTime)}-${dateFormatTime(endTime)}`;
};

export const checkUndefined = value => {
	const targetSet = new Set([undefined, 'undefined', null, 'null']);
	return targetSet.has(value);
};

export async function getPDFCover(link) {
	try {
		const pdf = await pdfjs.getDocument(link).promise;
		const page = await pdf.getPage(1);

		const viewport = page.getViewport({ scale: 1 });
		const canvas = document.createElement('canvas');
		const context = canvas.getContext('2d');
		canvas.width = viewport.width;
		canvas.height = viewport.height;

		await page.render({ canvasContext: context, viewport: viewport }).promise;

		return canvas.toDataURL('image/png', 1);
	} catch {
		return '';
	}
}

export function hexToRgb(hex) {
	hex = hex.replace(/^#/, '');

	if (hex.length === 3) {
		hex = hex
			.split('')
			.map(x => x + x)
			.join('');
	}

	const r = parseInt(hex.slice(0, 2), 16);
	const g = parseInt(hex.slice(2, 4), 16);
	const b = parseInt(hex.slice(4, 6), 16);

	return {
		r,
		g,
		b
	};
}

/**
 * 将数字转换为带中文单位的字符串
 * @param {number} amount - 需要转换的数字
 * @return {string} - 转换后的字符串
 */
export const convertNumberToCNUnit = amount => {
	// 检查输入是否为数字
	if (typeof amount !== 'number') {
		return { value: '- -', unit: '' };
	}

	const positive = amount > 0 ? 1 : -1;
	amount = Math.abs(amount);

	// 定义单位和对应的值
	const units = [
		{ name: '万亿', value: 1e12 },
		{ name: '亿', value: 1e8 },
		{ name: '万', value: 1e4 }
	];

	const en_units = [
		{ name: 'B', value: 1e9 },
		{ name: 'M', value: 1e6 },
		{ name: 'K', value: 1e3 }
	];

	const hkUnits = [
		{ name: '萬億', value: 1e12 },
		{ name: '億', value: 1e8 },
		{ name: '萬', value: 1e4 }
	];

	const selectedUnits = i18n.locale === EN ? en_units : i18n.locale === ZH_HK ? hkUnits : units;

	// 遍历单位，找到合适的单位进行转换
	for (let unit of selectedUnits) {
		if (amount >= unit.value) {
			return { value: ((positive * amount) / unit.value).toFixed(2), unit: unit.name };
		}
	}

	// 如果没有合适的单位，直接返回原值
	return { value: (positive * amount).toFixed(2), unit: '' };
};
export const convertNumberToStr = num => {
	const obj = convertNumberToCNUnit(num);
	return obj.value + obj.unit;
};

/**
 * 调整颜色值，加上一点白色，一般是 echarts 使用
 * @param {string} color 如 #eeff12
 * @param {number} amount 混合白色比例
 * @returns {string}
 */
export function transformColor(color, amount = 0.2) {
	if (!color) {
		return '';
	}
	// 将颜色转换为 RGB 值
	let r = parseInt(color.slice(1, 3), 16);
	let g = parseInt(color.slice(3, 5), 16);
	let b = parseInt(color.slice(5, 7), 16);

	// 计算加入白色后的 RGB 值
	r = Math.round((1 - amount) * r + amount * 255);
	g = Math.round((1 - amount) * g + amount * 255);
	b = Math.round((1 - amount) * b + amount * 255);

	// 将 RGB 值转换为十六进制颜色值
	color = '#' + r.toString(16).padStart(2, '0') + g.toString(16).padStart(2, '0') + b.toString(16).padStart(2, '0');
	return color;
}

export function splitFullCode(fullCode) {
	const regex = /^([a-zA-Z]*)(\d+)$/;
	const match = fullCode.match(regex);

	if (match) {
		return { market: match[1], code: match[2] };
	} else {
		return { market: '', code: '' }; // 如果没有匹配，返回空字符串
	}
}

export const parseQueryParams = url => {
	const queryString = url.split('?')[1];
	if (queryString) {
		const params = new URLSearchParams(queryString);
		const result = {};
		for (const [key, value] of params) {
			result[key] = value;
		}
		return result;
	}
	return {};
};

export const calcYoY = (val, yoyVal) => {
	if (val != undefined && yoyVal != undefined) {
		if (yoyVal === 0) {
			if (val === 0) {
				return 0;
			} else if (val > 0) {
				return 100;
			} else {
				return -100;
			}
		} else {
			return ((val - yoyVal) / Math.abs(yoyVal)) * 100;
		}
	} else {
		return null;
	}
};

/**
 * 深拷贝
 */
export const deepClone = obj => {
	if (typeof obj !== 'object' || obj === null) {
		return obj;
	}
	let res;
	if (obj instanceof Array) {
		res = [];
	} else {
		res = {};
	}
	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			res[key] = deepClone(obj[key]);
		}
	}
	return res;
};

export const checkErrorValue = value => {
	const targetSet = new Set([undefined, 'undefined', null, 'null']);
	return targetSet.has(value);
};
export const isErrorValue = (key, value) => {
	if (checkErrorValue(value)) {
		console.warn(`No Value [${key}]: ${value}`);
		return true;
	}
	return false;
};
